import { Component, OnInit, inject } from '@angular/core'
import { TbMenuComponent } from '@components-library/tb-menu'
import { CurrentUser, User } from '@core/models'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Observable } from 'rxjs'
import {
    ExpandMods,
    SideNavigationService,
} from '@components-library/tb-side-navigation-layout/side-navigation.service'
import { UserFacadeService } from '@services/store-facade'
import { UserSettingsContentComponent } from 'src/app/feature/user-settings/user-settings-content/user-settings-content.component'
import { UserAvatarComponent } from 'src/app/shared/user-avatar/user-avatar.component'
import { MatMenuModule } from '@angular/material/menu'
import { AsyncPipe } from '@angular/common'

@UntilDestroy()
@Component({
    selector: 'app-user-settings',
    templateUrl: './user-setting.component.html',
    styleUrls: ['./user-settings.component.sass'],
    imports: [
        MatMenuModule,
        UserAvatarComponent,
        UserSettingsContentComponent,
        AsyncPipe,
        TbMenuComponent,
    ],
})
export class UserSettingsComponent implements OnInit {
    private readonly sideNavigationService = inject(SideNavigationService)
    private readonly userFacadeService = inject(UserFacadeService)

    userInfo$: Observable<User | null> = this.userFacadeService.currentUserEntity$
    currentUser$: Observable<CurrentUser | null> = this.userFacadeService.currentUser$
    hideName = false

    ngOnInit(): void {
        this.sideNavigationService.state$.pipe(untilDestroyed(this)).subscribe((value) => {
            this.hideName = value.expand === ExpandMods.COLLAPSED
        })
    }
}
